import React, { Component } from "react";
import { Row, Typography } from "antd";
import ContentEditable from "react-contenteditable";

import "./TagsInputBox.scss";

const { Text } = Typography;

export default class TagsInputBox extends Component {
  cleanse = (input = "") => {
    return input.replace(/font-family/g, "f");
  };
  handleKeyPress = (e) => {
    const { value, onChange } = this.props;
    let newValue = value;

    if (e.keyCode === 13 && !value.includes("<li>")) {
      newValue = `<li>${newValue}</li>`;

      onChange(this.cleanse(newValue));
    }
  };

  handleBlur = () => {
    const { value, onChange } = this.props;
    let newValue = value;
    if (newValue) {
      newValue = newValue.replace(/<[^/>][^>]*><\/[^>]+>|<li><br><\/li>/g, "");
      onChange(this.cleanse(newValue));
    }
  };

  render() {
    const { label, value, disabled, onChange, classes } = this.props;

    return (
      <Row className="tags-input-box-container">
        <Row className="label">
          <Text>{label}</Text>
        </Row>
        <Row>
          <ContentEditable
            className={`${classes ? classes : "editable-content"} ${disabled ? 'editable-content-disabled' : ''}`}
            tagName="div"
            html={value || ""}
            disabled={disabled || false}
            onChange={(e) => {
              onChange(this.cleanse(e.target.value));
            }}
            onKeyDown={(e) => this.handleKeyPress(e)}
            onBlur={this.handleBlur}
          />
        </Row>
      </Row>
    );
  }
}
